import React, { Component } from "react";
import StartButton from "../button/startButton/StartButton";
import "./testDescription.css";
import { NavLink } from "react-router-dom";
import Interweave from "interweave";

class TestDescription extends Component {
    componentDidMount() {
        this.props.updateDescVisibility(true);
    }

    componentWillUnmount() {
        this.props.updateDescVisibility(false);
    }

    render() {
        console.log("some");
        const {
            title,
            description,
            url,
            testName,
            done,
            answers,
            answerTestName
        } = { ...this.props };
        let userAnswers = {};
        userAnswers.name = answerTestName;
        userAnswers.answers = answers;
        localStorage.setItem("userAnswers", JSON.stringify(userAnswers));
        let answersButton = null;
        if (done) {
            answersButton = (
                <NavLink to={`${process.env.PUBLIC_URL}/userAnswers`}>
                    <button className="button">მონაცემების ნახვა</button>
                </NavLink>
            );
        }

        let element;

        if(url === 'Test8/modes'){
            element = (
            <StartButton
            url={url}
            findIfTrialNeeded={this.props.findIfTrialNeeded}
            updateTestPercent={this.props.updateTestPercent}
            isTrialNeeded={this.props.isTrialNeeded}
            percent={this.props.percent}
            testName={testName}
            testPercent={this.props.testPercent}
            id={this.props.id}
        />
            )
        }
        else{
            element = (
            <section className="content-holder test-detailed">
                <div className="test-description">
                    <h1 className="test-name">{title}</h1>
                    <div className="test-desc-holder">
                        <p
                            className="test-description-text"
                            // dangerouslySetInnerHTML={description}
                        >
                            <Interweave content={description} />
                        </p>
                    </div>
                    <StartButton
                        url={url}
                        findIfTrialNeeded={this.props.findIfTrialNeeded}
                        updateTestPercent={this.props.updateTestPercent}
                        isTrialNeeded={this.props.isTrialNeeded}
                        percent={this.props.percent}
                        testName={testName}
                        testPercent={this.props.testPercent}
                        id={this.props.id}
                    />
                    <div className="tests-button">
                        <p>
                            <button
                                className="button"
                                onClick={this.props.backToTest}
                            >
                                ტესტების ჩამონათვალზე დაბრუნება
                            </button>
                        </p>
                        <p>{answersButton}</p>
                    </div>
                </div>
            </section>
            )
        }

        return (
            <React.Fragment>
            {element}
            </React.Fragment>


        );
    }
}

export default TestDescription;
